import React from "react";
import {Button, Card, Col, Input, InputNumber, Row, Switch} from "antd";
import * as PermissionPraisindoBackend from "./backend/PermissionPraisindoBackend";
import * as Setting from "./Setting";
import i18next from "i18next";

class PermissionsPraisindoEditPage extends React.Component {
  constructor(props) {
    super(props);

    const {location, match} = props;
    const permissionData = location.permissionData || {};
    const mode = location.mode !== undefined ? location.mode : "edit";
    const isAddMode = location.mode === "add";
    const organization = localStorage.getItem("organization");
    const isAllOrganization = organization === "All";
    const owner = !isAddMode
      ? match.params.owner
      : isAllOrganization
        ? "built-in"
        : organization;

    this.state = {
      permission: permissionData,
      mode: mode,
      owner: owner,
    };
  }

  parsePermissionField(key, value) {
    if ([""].includes(key)) {
      value = Setting.myParseInt(value);
    }
    return value;
  }

  updatePermissionField(key, value) {
    value = this.parsePermissionField(key, value);

    const permission = {...this.state.permission};
    permission[key] = value;
    this.setState({
      permission: permission,
    });
  }

  renderPermissionPraisindo() {
    return (
      <Card size="small" title={
        <div>
          {this.state.mode === "add" ? i18next.t("general:Add Permission") : i18next.t("general:Edit Permission")}&nbsp;&nbsp;&nbsp;&nbsp;
          <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitPermissionPraisindo(true)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} onClick={() => this.props.history.push({
            pathname: "/role-permissions",
          })}>{i18next.t("general:Cancel")}</Button> : null}
        </div>
      } style={(Setting.isMobile()) ? {margin: "5px"} : {}} type="inner">
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Owner"), i18next.t("general:Owner - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.owner} disabled onChange={e => {
              this.updatePermissionField("owner", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Service"), i18next.t("general:Service - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.permission.service} onChange={e => {
              this.updatePermissionField("service", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Feature"), i18next.t("general:Feature - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.permission.feature} onChange={e => {
              this.updatePermissionField("feature", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Action Permission"), i18next.t("general:Action Permission - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.permission.action} onChange={e => {
              this.updatePermissionField("action", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Label"), i18next.t("general:Label - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Input value={this.state.permission.label} onChange={e => {
              this.updatePermissionField("label", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Sort Order"), i18next.t("general:Sort Order - Tooltip"))} :
          </Col>
          <Col span={22} >
            <InputNumber value={this.state.permission.sortOrder} min={0} max={65535} onChange={e => {
              this.updatePermissionField("sortOrder", e);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
            {Setting.getLabel(i18next.t("general:Is enabled"), i18next.t("general:Is enabled - Tooltip"))} :
          </Col>
          <Col span={1} >
            <Switch checked={this.state.permission.isEnabled} onChange={checked => {
              this.updatePermissionField("isEnabled", checked);
            }} />
          </Col>
        </Row>
      </Card>
    );
  }

  submitPermissionPraisindo(exitAfterSave) {
    const permission = {
      owner: this.state.owner,
      service: this.state.permission.service,
      feature: this.state.permission.feature,
      action: this.state.permission.action,
      isEnabled: this.state.permission.isEnabled,
      label: this.state.permission.label,
      sortOrder: this.state.permission.sortOrder,
    };
    if (this.state.mode === "add") {
      PermissionPraisindoBackend.addPermissionPraisindo(permission)
        .then((res) => {
          if (res.status === "ok") {
            Setting.showMessage("success", i18next.t("general:Successfully saved"));
            if (exitAfterSave) {
              this.props.history.push("/role-permissions");
            } else {
              this.props.history.push("/role-permissions");
            }
          } else {
            Setting.showMessage("error", `${i18next.t("general:Failed to save")}: ${res.msg}`);
          }
        })
        .catch(error => {
          Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
        });
    } else {
      PermissionPraisindoBackend.updatePermissionPraisindo(this.state.permission.id, permission)
        .then((res) => {
          if (res.status === "ok") {
            Setting.showMessage("success", i18next.t("general:Successfully saved"));
            if (exitAfterSave) {
              this.props.history.push("/role-permissions");
            } else {
              this.props.history.push("/role-permissions");
            }
          } else {
            Setting.showMessage("error", `${i18next.t("general:Failed to save")}: ${res.msg}`);
          }
        })
        .catch(error => {
          Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
        });
    }
  }

  deleteRole() {
    PermissionPraisindoBackend.deletePermission(this.state.permission.id, this.state.permission.owner)
      .then((res) => {
        if (res.status === "ok") {
          this.props.history.push("/roles");
        } else {
          Setting.showMessage("error", `${i18next.t("general:Failed to delete")}: ${res.msg}`);
        }
      })
      .catch(error => {
        Setting.showMessage("error", `${i18next.t("general:Failed to connect to server")}: ${error}`);
      });
  }

  render() {
    return (
      <div>
        {
          this.state.permission !== null ? this.renderPermissionPraisindo() : null
        }
        <div style={{marginTop: "20px", marginLeft: "40px"}}>
          <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitPermissionPraisindo(true)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} size="large" onClick={() => this.props.history.push({
            pathname: "/role-permissions",
          })}>{i18next.t("general:Cancel")}</Button> : null}
        </div>
      </div>
    );
  }
}

export default PermissionsPraisindoEditPage;
